// Sterling density: relative dates in lists. Recent values scan faster
// (`17:35 · today`, `yesterday`, `3d ago`); older values fall back to
// absolute (`2026-05-17`). Used across list screens.
export function formatRelativeDate(iso: string): string {
  const then = new Date(iso);
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfThen = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const dayDiff = Math.round(
    (startOfToday.getTime() - startOfThen.getTime()) / (24 * 60 * 60 * 1000),
  );
  const hh = String(then.getHours()).padStart(2, '0');
  const mm = String(then.getMinutes()).padStart(2, '0');
  if (dayDiff === 0) return `${hh}:${mm} · today`;
  if (dayDiff === 1) return `${hh}:${mm} · yesterday`;
  if (dayDiff > 1 && dayDiff <= 7) return `${dayDiff}d ago`;
  return then.toISOString().slice(0, 10);
}

// Absolute formats — for detail pages where the user wants the exact value.
export function formatDate(iso: string): string {
  return new Date(iso).toISOString().slice(0, 10);
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toISOString().slice(0, 19).replace('T', ' ');
}
